import GuestGuard from '../guards/authGuard/GuestGaurd';
import AuthGuard from 'src/guards/authGuard/AuthGuard';

import Loadable from '../layouts/full/shared/loadable/Loadable';
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const EmployerInvite = Loadable(lazy(() => import('../views/admin-portal/employer-invite')));
const Login = Loadable(lazy(() => import('../views/authentication/auth1/Login')));
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));
const ViewWrapper = Loadable(lazy(() => import('./wrapper/ViewWrapper')));
const Tenant = Loadable(lazy(() => import('../views/admin-portal/tenant-details')));
const DashboardCards = Loadable(lazy(() => import('../views/dashboard/Main')));
const ApplicationList = Loadable(lazy(() => import('../views/admin-portal/application-list')));
const InvoiceList = Loadable(lazy(() => import('../views/admin-portal/invoice-list')));
const PayrollSummary = Loadable(lazy(() => import('../views/admin-portal/payroll-summary')));
const ApplicationDetails = Loadable(
  lazy(() => import('../views/application-details/ApplicationsDetails')),
);
const TenantList = Loadable(lazy(() => import('../views/admin-portal/tenant-list')));
const EmployerList = Loadable(lazy(() => import('../views/admin-portal/employer-list')));
const Receipts = Loadable(lazy(() => import('../views/admin-portal/receipts')));

export const baseAdminURL = process.env.REACT_APP_ADMIN_PORTAL_ROUTE as string;

export const adminRoutes = [
  {
    path: baseAdminURL,
    element: (
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    ),
    children: [
      { path: `${baseAdminURL}`, element: <Navigate to={`${baseAdminURL}/dashboard`} /> },
      {
        path: `${baseAdminURL}/dashboard`,
        exact: true,
        element: (
          <ViewWrapper title="Dashboard" description="Dashboard page">
            <DashboardCards />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/applications`,
        exact: true,
        element: (
          <ViewWrapper title={'Applications'}>
            <ApplicationList />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/invoices`,
        exact: true,
        element: (
          <ViewWrapper title={'Invoices'}>
            <InvoiceList />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/applications/:id`,
        exact: true,
        element: (
          <ViewWrapper title={'Application'}>
            <ApplicationDetails />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/receipts`,
        exact: true,
        element: (
          <ViewWrapper title="Receipts">
            <Receipts />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/tenants`,
        exact: true,
        element: (
          <ViewWrapper title={'Employers'}>
            <TenantList />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/tenants/:tenantId/employers`,
        exact: true,
        element: (
          <ViewWrapper title={'Employer'}>
            <EmployerList />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/payroll-summary`,
        exact: true,
        element: (
          <ViewWrapper title={'Payroll Summary'}>
            <PayrollSummary />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/tenants/:tenantId/employers/invite`,
        exact: true,
        element: (
          <ViewWrapper title={'Employer Invite'}>
            <EmployerInvite />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseAdminURL}/tenants/:tenantId`,
        exact: true,
        element: (
          <ViewWrapper title={'Employer'}>
            <Tenant />
          </ViewWrapper>
        ),
      },
    ],
  },
  {
    path: '/',
    element: (
      <GuestGuard>
        <BlankLayout />
      </GuestGuard>
    ),
    children: [{ path: `${baseAdminURL}/auth/login`, element: <ViewWrapper title="Login"><Login/></ViewWrapper> }],
  },
];
